export enum CharacterStates {
    DIE = "DIE",
    HIT = "HIT",
    IDLE = "IDLE",
    THROW = "THROW"
}
